/* @flow */
import * as React from 'react';

import Time from 'components/Time';

import Text from 'components/Text';
import type { Props as TextProps } from 'components/Text';

import getField from '../ComposableTableField';
import type { Field } from '../ComposableTableField';

type Props = {
  content: any,
  textProps: $Shape<TextProps>,
};

function TextCell({ content, textProps }: Props) {
  return <Text {...textProps}>{content}</Text>;
}

export function getTextCellGenerator(field: Field, textProps?: $Shape<TextProps>) {
  return (data: Object) => {
    return <TextCell content={getField(data, field)} textProps={textProps || {}} />;
  };
}

export function getArrayTextCellGenerator(
  field: Field,
  delimiter: string,
  transformCallback?: string => string,
  textProps?: $Shape<TextProps>
) {
  return (data: Object) => {
    const content = getField(data, field).map(
      item => (transformCallback ? transformCallback(item) : item)
    );

    return <TextCell content={content.join(', ')} textProps={textProps || {}} />;
  };
}

export function getTimestampCellGenerator(
  field: Field,
  textProps?: $Shape<TextProps>,
  prefix?: string
) {
  return (data: Object) => {
    const fieldValue = getField(data, field);
    let content;

    if (!fieldValue || isNaN(new Date(fieldValue))) {
      // invalid
      content = null;
    } else {
      const time = (
        <Time
          date={new Date(fieldValue)}
          month="short"
          day="numeric"
          year="numeric"
          hour="numeric"
          minute="numeric"
          hour12
        />
      );
      content = prefix ? (
        <React.Fragment>
          {prefix} {time}
        </React.Fragment>
      ) : (
        time
      );
    }

    return <TextCell content={content} textProps={textProps || {}} />;
  };
}

export function getDatestampCellGenerator(
  field: Field,
  textProps?: $Shape<TextProps>,
  prefix?: string
) {
  return (data: Object) => {
    const fieldValue = getField(data, field);
    let content;

    if (!fieldValue || isNaN(new Date(fieldValue))) {
      // invalid
      content = null;
    } else {
      const time = <Time date={new Date(fieldValue)} month="short" day="numeric" year="numeric" />;
      content = prefix ? (
        <React.Fragment>
          {prefix} {time}
        </React.Fragment>
      ) : (
        time
      );
    }

    return <TextCell content={content} textProps={textProps || {}} />;
  };
}
